export enum EDomain {
  Assessment = 0,
  Speed = 1,
  Reasoning = 2,
  Attention = 3,
  Memory = 4,
  SelfRegulation = 5,
  CFQScore = 100,
  Forgetfulness = 101,
  Distractibility = 102,
  FalseTriggering = 103,
  Mood = 20001,
}

export interface IDomainWeight {
  id: EDomain;
  weight: number;
}

export const NO_ALERT_TYPE = 'noAlert';

export enum EExerciseCategory {
  Medium = 0,
  Easy = 1,
  Hard = 2,
}

export interface IDomainCalculation {
  value: number;
  timestamp: number;
  cycleId: number;
  domainId: number;
}

export interface ITrainingIntensity {
  intensity: number;
  session_amount_in_cycle: number;
  workout_amount_in_session: number;
  cycle_duration_days: number;
}

interface IAssessmentWorkoutConfigOPXP {
  id: number;
  image: string;
  description: string;
  title: string;
}

type TAssessmentSessionConfig = Array<IAssessmentWorkoutConfigOPXP>;

export interface IAssessmentConfigOPXP {
  from_cycle_id: number;
  assessment_ids: Array<TAssessmentSessionConfig>;
}

export type Unpromisify<T> = T extends Promise<infer U> ? U : T;

type TApiFunctionReturn<T extends (...args: any) => Promise<unknown>> = ReturnType<T>;

export type TApiFetchResponse<T extends (...args: any) => Promise<unknown>> = Unpromisify<TApiFunctionReturn<T>>;

// Firebase config types
export interface IWorkoutPopularityConfig {
  variant?: string;
  popularity_filter_active: boolean;
  popularity_workouts_percentage_for_session: Array<{ until_session: number; available_percentage: number }>;
  workout_group_ids_by_popularity: Array<number>;
}

export interface IDay0Banner {
  variant: string;
  banner_content: boolean;
}

export interface IWelcomeLp {
  variant: string;
  enabled: boolean;
}

export interface IChallenge {
  // deprecated
  variant: string;
  // deprecated
  activate: boolean;
  challenge_workout_ids?: number[];
  startsAt?: number;
}

interface IBlogPreviewEnabled {
  variant: string;
  preview: true;
  title: string;
  image_url: string;
  content: string;
  article_url: string;
}

interface IBlogPreviewDisabled {
  variant: string;
  preview: false;
}

export type TBlogPreviewConfig = IBlogPreviewEnabled | IBlogPreviewDisabled;

export interface IWelcomeMessageConfig {
  // split test variant
  variant: number | string;
  // show or not show new welcome message
  welcome_message: boolean;
}

export interface IMacOsWarningConfig {
  enabled: boolean;
  versions: string;
}
